// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__32tgO","name":"Header_name__d9MFC","birthday":"Header_birthday__1BrOI","skeleton":"Header_skeleton__2z3A1"};